// Реакция на смену тарифа в форме редактирования брони.
//
// Вынесено из watcher'а selected_tariff_id в BookingCard по прецеденту
// editPanels.js / addonsMath.js: mount 12.8k-строчного компонента ради пяти
// строк логики не нужен, а тестировать копию watcher'а внутри спека —
// бессмысленно, копия не ловит правку в компоненте.
//
// ctx — это `this` компонента: selected_tariff_id, tariffs, tariff, booking,
// editDialog, calculateCost().

/**
 * Применяет выбранный (или снятый) тариф к состоянию карточки.
 *
 * @param {object} ctx экземпляр BookingCard
 */
export function applyTariffSelection(ctx) {
  if (ctx.selected_tariff_id) {
    if (ctx.booking && ctx.booking.prolongs && ctx.booking.prolongs.length > 0) {
      // Если есть продление, то не учитываем тариф, он уже в цене
      return;
    }
    ctx.tariff = ctx.tariffs.find((tariff) => tariff.id == ctx.selected_tariff_id);
    // FT-084 STEP-12: tariff {sum,percent} is a CTR-01 pricing input
    // (Pricing::Engine applies it server-side) — was calculateCostWithTariff().
    ctx.calculateCost();
    return;
  }

  ctx.tariff = null;
  // Обнуление booking.tariff_id — реакция на то, что оператор СНЯЛ тариф в
  // открытой форме. Тот же сброс selected_tariff_id делает
  // ft108ResetEditSections() при ЗАКРЫТИИ формы (крестик, «Закрыть»,
  // success-ветка editSave), и без гарда по editDialog он стирал тариф из
  // карточки: watcher Vue отрабатывает после синхронного блока, то есть ПОСЛЕ
  // строки `booking.tariff_id = selected_tariff_id` в editSave. Восстановить
  // значение на пути сохранения было некому (getBooking там не зовётся) —
  // только что сохранённый тариф пропадал из карточки до перезагрузки вкладки,
  // хотя в базе и в расчётах он был. На путях закрытия то же обнуление
  // происходило и лечилось гонкой с ответом getBooking().
  if (ctx.editDialog) {
    ctx.booking.tariff_id = null;
  }
  ctx.calculateCost();
}
